export default __webpack_public_path__ + "static/media/icon-tiktok.16e7799a.svg";